import { createSelector } from '@reduxjs/toolkit';
import type { IUserProfileStatistics } from '../../types/userProfile';
import { userProfileClientInfoSelector } from './userProfileClientInfoSelector';

export const userProfileStatisticsSelector = createSelector(
  [userProfileClientInfoSelector],
  (clientInfo): IUserProfileStatistics | null => {
    return clientInfo?.statistics || null;
  },
);
